import { render, staticRenderFns } from "./BtcWallet.vue?vue&type=template&id=4736d0e6&scoped=true"
import script from "./BtcWallet.vue?vue&type=script&lang=js"
export * from "./BtcWallet.vue?vue&type=script&lang=js"
import style0 from "./BtcWallet.vue?vue&type=style&index=0&id=4736d0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736d0e6",
  null
  
)

export default component.exports